import React from 'react';
import { Row, Col, Input, Form, DatePicker, Checkbox, Card } from 'antd';
import FormInput from 'components/FormInput';
import Text from 'antd/lib/typography/Text';
import moment from 'moment';
import { toCurrency } from 'utils/utils';
import ParListSelect from 'components/ParListSelect';
import { FormInstance } from 'antd/lib/form';
import { shouldUpdateCompare } from 'utils/utils2';
import ThirdPartyInput from 'components/ThirdPartyInput';
import ContractListSelect from '../../../../components/ContractListSelect';
import Value from 'components/Value';
import AccountingEntryModal from 'pages/Accounting/Components/AccountingEntryModal';
import ContractDetailModal from 'pages/Accounting/Components/ContractDetailModal';
import UtinaCard from 'components/UtinaCard';
import CIDetail from '..';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { isNil } from 'lodash';
import ModalControllerNV from 'components/ModalControllerNV';
import { getThirdPartyById } from 'services/thirdParty';

export type TabClientInvoiceProps = {
  form: FormInstance;
};

const TabClientInvoice = ({ form }: TabClientInvoiceProps) => {
  const isCreate = Boolean(form.getFieldValue('isCreate'));
  return (
    <Card type="inner" title={<GetLabel label="generalinformation" />}>
      <Row style={{ padding: '15px' }} gutter={16}>
        <Col span={24}>
          <Row gutter={16}>
            <FormInput col md={4} name="cireference">
              <Value />
            </FormInput>

            <Form.Item noStyle shouldUpdate={shouldUpdateCompare('cirejected')}>
              {({ getFieldValue }) => (
                <FormInput
                  name="citype"
                  col
                  md={4}
                  rules={[{ required: true }]}
                >
                  {isCreate ? (
                    <ParListSelect
                      disabled={!isCreate}
                      parcode={isCreate ? 'CITYPEMAN' : 'CITYPE'}
                      onChange={(e) => {
                        e === 'MISCFEES'
                          ? form.setFieldsValue({ ciltype: 'Fees' })
                          : form.setFieldsValue({ ciltype: e });
                      }}
                      style={{ width: '100%' }}
                    />
                  ) : (
                    <Text>{getFieldValue('citypelabel')}</Text>
                  )}
                </FormInput>
              )}
            </Form.Item>

            <FormInput col md={4} name="flagcn">
              <Checkbox checked={form.getFieldValue('flagcn')} disabled />
            </FormInput>

            <Form.Item
              noStyle
              shouldUpdate={shouldUpdateCompare([
                'refinvoicecreditnote',
                'flagcn',
                'ciidcreditnote',
              ])}
            >
              {({ getFieldValue }) =>
                !getFieldValue('flagcn') &&
                getFieldValue('ciidcreditnote') && (
                  <FormInput
                    name="refinvoicecreditnote"
                    comcode={
                      form.getFieldValue('flagcn')
                        ? 'refinvoicecreditnote'
                        : 'Notflagcn'
                    }
                    col
                    md={4}
                  >
                    <ModalControllerNV
                      content={({ setVisible, visible }) => (
                        <a onClick={() => setVisible(true)}>
                          {getFieldValue('refinvoicecreditnote') === '' ||
                          !getFieldValue('refinvoicecreditnote')
                            ? 'No'
                            : getFieldValue('refinvoicecreditnote')}
                        </a>
                      )}
                      modal={({ setVisible, visible }) => (
                        <CIDetail
                          ciid={getFieldValue('ciidcreditnote')}
                          onCancel={() => setVisible(false)}
                          showAsModal
                          visible={visible}
                          showButtons={false}
                        />
                      )}
                    />
                  </FormInput>
                )
              }
            </Form.Item>

            <Form.Item
              noStyle
              shouldUpdate={shouldUpdateCompare('statuslabel')}
            >
              {({ getFieldValue }) => (
                <FormInput
                  name="statuslabel"
                  style={{ color: 'green' }}
                  col
                  md={6}
                >
                  <Text>
                    {!getFieldValue('cistatus')
                      ? form.setFieldsValue({
                          cistatus: 'INIT',
                          statuslabel: 'Initial',
                        })
                      : ''}
                    {getFieldValue('statuslabel')}{' '}
                    {moment(getFieldValue('created_at')).format('YYYY-MM-DD')}
                  </Text>
                </FormInput>
              )}
            </Form.Item>
          </Row>
          <Row gutter={16}>
            <UtinaCard
              level={5}
              comcode="general_info"
              style={{ color: '#000', marginLeft: 20, paddingTop: 20 }}
              lg={14}
            >
              <Col span={24}>
                <Row gutter={16}>&nbsp;</Row>
                <Row gutter={25}>
                  <FormInput
                    name="cidocreference"
                    col
                    md={8}
                    rules={[{ required: true }]}
                  >
                    <Input disabled={!isCreate} />
                  </FormInput>

                  <FormInput name="cidocdate" col md={8}>
                    <DatePicker disabled />
                  </FormInput>

                  <FormInput name="currcode" col md={8} shouldUpdate>
                    <ParListSelect disabled={!isCreate} parcode="CURRENCY" />
                  </FormInput>

                  <FormInput
                    name="thirdparty"
                    col
                    md={16}
                    rules={[{ required: true }]}
                  >
                    <ThirdPartyInput
                      hideSearchButton={!isCreate}
                      isCreate={isCreate ? !isCreate : isCreate}
                      role="CLIENT"
                      onChange={(tp) => {
                        getThirdPartyById({ tpid: tp.tpid }).then(
                          (response) => {
                            form.setFieldsValue({
                              tpinvoicingaddress:
                                response.data.address.tpmainadrstreet1,
                              tpinvoicingaddress2:
                                response.data.address.tpmainadrstreet2,
                              tpinvoicingcity:
                                response.data.address.tpmainadrcitylabel,
                              tpinvoicingregion:
                                response.data.address.tpmainadrregion,
                              tpinvoicingzipcode:
                                response.data.address.tpmainadrzipcode,
                            });
                          }
                        );
                        form.setFieldsValue({
                          clientInvoiceLines: [],
                          clientInvoiceSchedules: [],
                          cinettotal: 0,
                          citaxtotal: 0,
                          cigrosstotal: 0,
                          cisamount: 0,
                          ctrreference: null,
                        });
                      }}
                    />
                  </FormInput>

                  <Form.Item
                    shouldUpdate={shouldUpdateCompare([
                      'thirdparty',
                      'cimultiplecontracts',
                      'currcode',
                      'ctreference',
                      'ctrreference',
                    ])}
                    noStyle
                  >
                    {({ getFieldValue }) =>
                      !getFieldValue('cimultiplecontracts') && (
                        <FormInput
                          name={!isCreate ? 'ctreference' : 'ctrreference'}
                          col
                          md={8}
                        >
                          {isCreate ? (
                            <ContractListSelect
                              disabled={isNil(getFieldValue('thirdparty'))}
                              tpreference={getFieldValue(['thirdparty', 'tpreference'])}
                              currcode={getFieldValue('currcode')}
                              form={form}
                            />
                          ) : (
                            <ContractDetailModal
                              ctreference={getFieldValue('ctreference')}
                              ctrid={getFieldValue('ctrid')}
                            />
                          )}
                        </FormInput>
                      )
                    }
                  </Form.Item>

                  {/* <Form.Item
                    noStyle
                    shouldUpdate={shouldUpdateCompare('cirejected')}
                  >
                    {({ getFieldValue }) => (
                      <FormInput name="cirejected" col md={8}>
                        <a style={{ color: 'blue' }}>
                          {getFieldValue('cistatus') === 'REJECT'
                            ? 'Yes'
                            : 'No'}
                        </a>
                      </FormInput>
                    )}
                  </Form.Item> */}
                </Row>
                <UtinaCard
                  level={5}
                  comcode="address"
                  style={{ color: '#000', paddingTop: 20 }}
                  lg={24}
                >
                  <Row gutter={32}>
                    <FormInput name="tpinvoicingaddress" col md={5}>
                      <Value />
                    </FormInput>
                    <FormInput name="tpinvoicingaddress2" col md={5}>
                      <Value />
                    </FormInput>
                    <FormInput name="tpinvoicingcitylabel" col md={5}>
                      <Value />
                    </FormInput>
                    <FormInput name="tpinvoicingregion" col md={4}>
                      <Value />
                    </FormInput>
                    <FormInput name="tpinvoicingzipcode" col md={4}>
                      <Value />
                    </FormInput>
                  </Row>
                </UtinaCard>
              </Col>
            </UtinaCard>

            <UtinaCard
              level={5}
              comcode="financial_info"
              style={{ color: '#000', marginLeft: 20, paddingTop: 20 }}
              lg={8}
            >
              <Col span={24}>
                <Row gutter={16}>&nbsp;</Row>
                <Row>
                  <Form.Item
                    noStyle
                    shouldUpdate={shouldUpdateCompare([
                      'cigrosstotal',
                      'currcode',
                    ])}
                  >
                    {({ getFieldValue }) => (
                      <FormInput name="cinettotal" col md={12}>
                        <Text strong>
                          {toCurrency(
                            getFieldValue('cinettotal'),
                            getFieldValue('currcode')
                          )}
                        </Text>
                      </FormInput>
                    )}
                  </Form.Item>
                  <Form.Item
                    noStyle
                    shouldUpdate={shouldUpdateCompare([
                      'cidueamount',
                      'currcode',
                      'citaxtotal',
                    ])}
                  >
                    {({ getFieldValue }) => (
                      <FormInput name="citaxtotal" col md={12}>
                        <Text strong>
                          {toCurrency(
                            getFieldValue('citaxtotal'),
                            getFieldValue('currcode')
                          )}
                        </Text>
                      </FormInput>
                    )}
                  </Form.Item>
                </Row>

                <Row>
                  <Form.Item
                    noStyle
                    shouldUpdate={shouldUpdateCompare([
                      'cigrosstotal',
                      'currcode',
                    ])}
                  >
                    {({ getFieldValue }) => (
                      <FormInput
                        name="cigrosstotal"
                        style={{ color: 'blue' }}
                        col
                        md={12}
                      >
                        <Text strong>
                          {toCurrency(
                            getFieldValue('cigrosstotal'),
                            getFieldValue('currcode')
                          )}
                        </Text>
                      </FormInput>
                    )}
                  </Form.Item>
                  <Form.Item
                    noStyle
                    shouldUpdate={shouldUpdateCompare([
                      'cidueamount',
                      'currcode',
                    ])}
                  >
                    {({ getFieldValue }) => (
                      <FormInput name="cidueamount" col md={12}>
                        <Text strong type="danger">
                          {toCurrency(
                            getFieldValue('cidueamount'),
                            getFieldValue('currcode')
                          )}
                        </Text>
                      </FormInput>
                    )}
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item shouldUpdate noStyle>
                    {({ getFieldValue }) => (
                      <FormInput name="accountingreference" col md={12}>
                        <Text>
                          <AccountingEntryModal
                            accountingReference={getFieldValue(
                              'accountingreference'
                            )}
                          />
                        </Text>
                      </FormInput>
                    )}
                  </Form.Item>
                  <FormInput name="accountingdate" col md={12}>
                    <Value />
                  </FormInput>
                </Row>
                <Row gutter={16}>&nbsp;</Row>
              </Col>
            </UtinaCard>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};
export default TabClientInvoice;
